import {
  MARK_COMPLETED, UNDO_COMPLETED, RECEIVED_CHECKLISTS,
} from './constants'

const initialState = {};

export default function checklistsReducer(checklists = initialState, action){

  switch(action.type){

    case RECEIVED_CHECKLISTS:
      return action.checklists;

    case MARK_COMPLETED:
      if(!checklists[action.id]){
         return {...checklists, ...{[action.id]: [action.date]}};
      }

      let unique = new Set([...checklists[action.id], action.date]);

      return {...checklists, ...{[action.id]: Array.from(unique)}}

    case UNDO_COMPLETED:
      if(!checklists[action.id]) return checklists;
      return {...checklists, [action.id]: checklists[action.id].filter(date => date.setHours(0,0,0,0) !== action.date.setHours(0,0,0,0))};

  }

  return checklists;
}

